import React, { useState, useEffect } from 'react'

import { getExtensiones } from '../../../API/Home/ExtensionesRequests';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';

const Extensiones = () => {

    const [Extensiones, setExtensiones] = useState([]);

    const columns = [
        {
            // Empleado
            field: 'Empleado',
            header: 'Empleado',
            className: 'colum-width-large',
        },
        {
            // Extension
            field: 'Extension',
            header: 'Extension',
            className: 'colum-width-small',
            align: 'center',
        },
        {
            // Correo
            field: 'Correo',
            header: 'Correo',
            className: 'colum-width-large',
        },
        {
            // Departamento
            field: 'Departamento',
            header: 'Departamento',
            className: 'colum-width-medium',
        },
        {
            // TelefonoPersonal
            field: 'TelefonoPersonal',
            header: 'Telefono personal',
            className: 'colum-width-large',
        },
    ];


    const table = {
        Columns: columns,
        Data: Extensiones
    }

    const getExtencionesData = async () => {
        const tempo = await getExtensiones();
        setExtensiones(tempo);
    }

    useEffect(() => {
        getExtencionesData();
    }, []);

  return (
    <div className='ExtencionesContainer'>
        {/* <DevExpress table={table} /> */}
        <AgGrid table={table} />
    </div>
  )
}

export default Extensiones